import React from 'react';
import './styles.css';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-page">
            <div className="privacy-container">
                <h1 className="privacy-title">Политика конфиденциальности</h1>

                <section className="privacy-section">
                    <h2>Общая информация</h2>
                    <p>
                        «Мы» — первый в России аграрный маркетплейс e-Feed, и в данном документе мы расскажем,
                        как и с какой целью мы, ООО «ПРОТЕКТФИД» («мы», «нами» или «e-Feed») собираем, храним,
                        используем ваши персональные данные, делимся ими и иным образом обрабатываем их, когда вы
                        посещаете или используете сайт e-feed.ru (далее — «Сайт»).
                    </p>
                    <p>
                        Мы обеспечиваем защиту персональных данных наших пользователей и гарантируем прозрачность
                        в их обработке. Ниже приведена информация о том, как мы обрабатываем личные данные, которые
                        могут быть получены в ходе использования нашего Сайта.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Основные понятия, используемые в Политике:</h2>
                    <ul className="privacy-definitions">
                        <li>
                            <strong>персональные данные</strong> — любая информация, относящаяся к прямо или косвенно
                            определенному или определяемому физическому лицу (субъекту персональных данных);
                        </li>
                        <li>
                            <strong>оператор персональных данных (оператор)</strong> — государственный орган,
                            муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими
                            лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие
                            цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия
                            (операции), совершаемые с персональными данными;
                        </li>
                        <li>
                            <strong>Сайт</strong> — сайт Оператора: www.e-feed.ru;
                        </li>
                        <li>
                            <strong>обработка персональных данных</strong> — любое действие (операция) или совокупность
                            действий (операций) с персональными данными, совершаемых с использованием средств автоматизации
                            или без их использования. Обработка персональных данных включает в себя в том числе:
                            <ul>
                                <li>сбор;</li>
                                <li>запись;</li>
                                <li>систематизацию;</li>
                                <li>накопление;</li>
                                <li>хранение;</li>
                                <li>уточнение (обновление, изменение);</li>
                                <li>извлечение;</li>
                                <li>использование;</li>
                                <li>передачу (распространение, предоставление, доступ);</li>
                                <li>обезличивание;</li>
                                <li>блокирование;</li>
                                <li>удаление;</li>
                                <li>уничтожение;</li>
                            </ul>
                        </li>
                        <li>
                            <strong>автоматизированная обработка персональных данных</strong> — обработка персональных
                            данных с помощью средств вычислительной техники;
                        </li>
                        <li>
                            <strong>распространение персональных данных</strong> — действия, направленные на раскрытие
                            персональных данных неопределенному кругу лиц;
                        </li>
                        <li>
                            <strong>предоставление персональных данных</strong> — действия, направленные на раскрытие
                            персональных данных определенному лицу или определенному кругу лиц;
                        </li>
                        <li>
                            <strong>блокирование персональных данных</strong> — временное прекращение обработки
                            персональных данных (за исключением случаев, если обработка необходима для уточнения
                            персональных данных);
                        </li>
                        <li>
                            <strong>уничтожение персональных данных</strong> — действия, в результате которых становится
                            невозможным восстановить содержание персональных данных в информационной системе персональных
                            данных и (или) в результате которых уничтожаются материальные носители персональных данных;
                        </li>
                        <li>
                            <strong>обезличивание персональных данных</strong> — действия, в результате которых становится
                            невозможным без использования дополнительной информации определить принадлежность персональных
                            данных конкретному субъекту персональных данных;
                        </li>
                        <li>
                            <strong>информационная система персональных данных</strong> — совокупность содержащихся в базах
                            данных персональных данных и обеспечивающих их обработку информационных технологий и технических
                            средств;
                        </li>
                        <li>
                            <strong>трансграничная передача персональных данных</strong> — передача персональных данных на
                            территорию иностранного государства органу власти иностранного государства, иностранному
                            физическому лицу или иностранному юридическому лицу.
                        </li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>Куки</h2>
                    <p>
                        Посещая или используя www.e-feed.ru (далее Сайт), Вы соглашаетесь с тем, что Оператор использует
                        определенные технологии мониторинга и отслеживания, такие как cookie, маяки, пиксели, теги, и скрипты
                        (в совокупности «Cookie»). Эти технологии используются для обеспечения, поддержания и улучшения Сайта,
                        для оптимизации наших предложений и маркетинговой деятельности (например, для отслеживания предпочтений
                        Пользователей, улучшения безопасности Сайта, выявления технических вопросов, а также мониторинга и
                        улучшения общей эффективности Сайта.
                    </p>

                    <h3>Что такое Cookie?</h3>
                    <p>
                        Cookie — это небольшие текстовые файлы, которые сохраняются через браузер на вашем компьютере
                        или мобильном устройстве. Они позволяют веб-сайтам хранить информацию, такую как пользовательские
                        предпочтения. Cookie обычно классифицируются как «сессионные cookie», которые автоматически удаляются
                        при закрытии браузера или «постоянные cookie», которые обычно остаются на Вашем устройстве до тех пор,
                        пока Вы их не удалите или они не истекут.
                    </p>
                    <p>
                        Если вы оставляете комментарий на нашем сайте, вы можете включить сохранение вашего имени,
                        адреса email и вебсайта в куки. Это делается для вашего удобства, чтобы не заполнять данные
                        снова при повторном комментировании. Эти куки хранятся в течение одного года.
                    </p>
                    <p>
                        Если у вас есть учетная запись на сайте и вы войдете в неё, мы установим временный куки для
                        определения поддержки куки вашим браузером, куки не содержит никакой личной информации и
                        удаляется при закрытии вашего браузера.
                    </p>
                    <p>
                        При входе в учетную запись мы также устанавливаем несколько куки с данными входа и настройками экрана.
                        Куки входа хранятся в течение двух дней, куки с настройками экрана — год. Если вы выберете
                        возможность «Запомнить меня», данные о входе будут сохраняться в течение двух недель. При выходе
                        из учетной записи куки входа будут удалены.
                    </p>
                    <p>
                        При редактировании или публикации статьи в браузере будет сохранен дополнительный куки, он не
                        содержит персональных данных и содержит только ID записи отредактированной вами, истекает через 1 день.
                    </p>
                    <p>
                        В большинстве браузеров файлы сookie принимаются автоматически, но у Вас есть возможность управлять
                        параметрами браузера для блокирования или удаления файлов сookie. Дополнительные инструкции по удалению
                        файлов cookie настройках Ваших браузеров. Некоторые функции Сайта зависят от использования файлов cookie.
                        Если Вы решите заблокировать файлы сookie, Вы не сможете входить в систему или использовать функции и
                        настройки, зависящие от файлов сookie. При удалении cookie-файлов удаляются любые хранящиеся в этих
                        файлах параметры и предпочтения, включая параметры, касающиеся рекламы; впоследствии потребуется
                        создать их заново.
                    </p>

                    <h3>Технические/необходимые cookie-файлы</h3>
                    <p>
                        необходимы для нормальной работы определенных областей Сайта. Они также позволяют распределять
                        нагрузку на серверы, собирать сведения о предпочтениях Пользователей относительно использования
                        файлов cookie и т. д. Cookie-файлы этой категории включают как файлы сеансов, так и постоянные
                        файлы cookie.
                    </p>

                    <h3>Аналитические cookie-файлы</h3>
                    <p>
                        предназначены для сбора сведений о том, каким образом посетители используют Сайт. Данные сведения
                        используются для составления отчетов и улучшения работы Сайта с целью сделать их более удобными
                        для использования и следить за их работой. Эти файлы cookie собирают обезличенные сведения.
                        Оператор может использовать аналитические инструменты и соответствующие cookie-файлы различных
                        поставщиков услуг, основные из них: Google Analytics, Яндекс.Метрика.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Данные, получаемые в процессе использования сайта</h2>
                    <p>Во время использования сайта, мы можем получать такие данные, как:</p>
                    <ul>
                        <li>куки;</li>
                        <li>данные о составе Ваших заказов, статусе и процессе их выполнения;</li>
                        <li>данные об избранных товарах, которые Вы выбрали на сайте;</li>
                        <li>данные об использовании промокодов, использованных на сайте;</li>
                        <li>данные, полученные в результате анализа иных данных, полученных при использовании сайта, либо предоставленных Вами;</li>
                        <li>данные об устройстве (включая MAC-адрес, IP-адрес, IDFA, Google Advertising ID, данные об операционной системе устройства, данные о браузере, разрешении экрана).</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>С кем мы делимся вашими данными</h2>
                    <p>
                        При использовании сайта, Вы соглашаетесь с тем, что сайт вправе предоставить персональные данные
                        партнёрам, другим третьим лицам, в частности, курьерским службам, организациям почтовой связи,
                        операторам связи, исключительно в целях выполнения Вашего заказа или другого действия, произведенного
                        покупателем через личный кабинет на сайте.
                    </p>
                    <p>Сайта вправе передавать персональные данные пользователей третьим лицам в следующих случаях:</p>
                    <ul>
                        <li>Пользователь явно выразил свое согласие на такие действия.</li>
                        <li>Передача необходима для исполнения договора, заключенного с пользователем.</li>
                        <li>Передача предусмотрена действующим законодательством.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>Как долго мы храним ваши данные</h2>
                    <p>
                        Если вы оставляете комментарий, то сам комментарий и его метаданные сохраняются неопределенно долго.
                        Это делается для того, чтобы определять и одобрять последующие комментарии автоматически, вместо
                        помещения их в очередь на одобрение.
                    </p>
                    <p>
                        Для пользователей с регистрацией на нашем сайте мы храним ту личную информацию, которую они указывают
                        в своем профиле. Все пользователи могут видеть, редактировать или удалить свою информацию из профиля
                        в любое время (кроме имени пользователя). Администрация вебсайта также может видеть и изменять эту
                        информацию.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Какие у вас права на ваши данные</h2>
                    <p>
                        При наличии учетной записи на сайте или если вы оставляли комментарии, то вы можете запросить файл
                        экспорта персональных данных, которые мы сохранили о вас, включая предоставленные вами данные. Вы
                        также можете запросить удаление этих данных, это не включает данные, которые мы обязаны хранить в
                        административных целях, по закону или целях безопасности.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Ваша контактная информация</h2>
                    <p>
                        В основном мы получаем персональные данные напрямую от вас и не из других источников. Следовательно,
                        вы вправе решать, хотите ли вы делиться с нами персональными данными или нет. Вы не обязаны
                        предоставлять нам какие-либо персональные данные. Если вы делитесь с нами такими данными, мы будем
                        использовать их так, как это описано ниже:
                    </p>
                    <ul>
                        <li>Персональная информация, предоставленная Вами при регистрации (создании учетной записи), такая как Ваше ФИО, номер телефона, адрес и наименование организации или ИП; Инн организации или ИП; Ваша электронная почта;</li>
                        <li>дата и время осуществления доступа к Сайту;</li>
                        <li>информация о Вашей активности во время использования Сайта (например, история поисковых запросов, данные о покупках в Сервисах, данные об организациях, лайки и предпочтения);</li>
                        <li>информация о геолокации;</li>
                        <li>данные Ваших платежных карт, иная платежная информация, предоставленная Вами, а также полученная от Партнеров или иных лиц, участвующих в проведении платежной операции с использованием Сайта e-Feed и/или в связи с оказанием Сайта платных услуг.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>Дополнительная информация</h2>
                    <p>
                        Администрация не проверяет достоверность персональных данных, предоставляемых Пользователем.
                    </p>
                    <p>
                        Действующая Политика конфиденциальности размещена на странице по адресу:{' '}
                        <a href="https://e-feed.ru/privacy-policy/" target="_blank" rel="noopener noreferrer">
                            https://e-feed.ru/privacy-policy/
                        </a>
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Как мы защищаем ваши данные</h2>
                    <p>
                        В большинстве случаев Персональная информация обрабатывается автоматически без доступа к ней
                        кого-либо из сотрудников e-Feed. В случае если такой доступ понадобится, то он может быть предоставлен
                        только тем сотрудникам e-Feed, которые нуждаются в этом для выполнения своих задач.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Какие принимаются процедуры против взлома данных</h2>
                    <p>
                        Мы обеспечиваем безопасность и сохраняем конфиденциальность ваших персональных данных. Для этого мы
                        принимаем все необходимые правовые, организационные и технические меры защиты данных, предусмотренные
                        Законом о персональных данных, чтобы защитить вас и ваши данные от неправомерного или случайного доступа,
                        уничтожения, изменения, блокирования, копирования, предоставления, распространения персональной
                        информации, а также от иных неправомерных действий в отношении ваших данных.
                    </p>
                    <p>
                        Для защиты и обеспечения конфиденциальности данных все сотрудники должны соблюдать внутренние правила
                        и процедуры в отношении обработки Персональной информации. Они также должны следовать всем техническим
                        и организационным мерам безопасности, действующим для защиты Вашей Персональной информации.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>От каких третьих сторон мы получаем данные</h2>
                    <p>
                        При использовании сайта мы можем передавать ваши данные третьим лицам, получать ваши данные от
                        третьих лиц, а также поручать третьим лицам обработку ваших данных.
                    </p>
                    <p>
                        Мы передаем, получаем данные или поручаем обработку данных третьим лицам только если это необходимо
                        для достижения целей обработки таких данных.
                    </p>
                    <p>
                        Третьи лица, которым данные могут передаваться или которым может поручаться обработка данных,
                        указываются в правилах работы сайта.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Правила и условия</h2>
                    <ul className="privacy-definitions">
                        <li><strong>Горячая линия</strong> — телефон службы поддержки Клиентов.</li>
                        <li><strong>Доставка</strong> — доставка Товара до места назначения, обозначенного Клиентом при оформлении Заказа на Сайте в случае, если Клиентом выбрана услуга «доставка».</li>
                        <li><strong>Доставщик</strong> — ИП, или физическое, или юридическое лицо, оказывающее услуги по Доставке Товара, с которым Клиент при оформлении Заказа заключает договор на Доставку; либо Партнёр e-Feed, осуществляющий Доставку Товара своими силами или с привлечением третьих лиц.</li>
                        <li><strong>Заказ</strong> — оформленный Клиентом на Сайте заказ на покупку Товара, в результате которого Клиент заключает договор на приобретение Товара e-Feed или Партнёром e-Feed, договор на Сборку данного Товара со Сборщиком, а в случае осуществления Доставки также договор Доставки данного Товара с Доставщиком на условиях, указанных в Правилах.</li>
                        <li><strong>Заявление о возврате</strong> — заявление Клиента о возврате Товара надлежащего либо ненадлежащего качества с указанием ФИО, паспортных данных, адреса регистрации Клиента и реквизитов карты и/или банковского счёта для возврата денежных средств.</li>
                        <li><strong>Партнёр e-Feed</strong> — юридическое лицо или ИП, являющиеся продавцами Товаров, предлагаемых Клиентам посредством Сайта.</li>
                        <li><strong>Клиент</strong> — физическое лицо, обладающее дееспособностью и необходимыми полномочиями для приобретения и оплаты Товаров через Сайт и осуществляющее регистрацию и/или заказ на Сайте.</li>
                        <li><strong>Личный кабинет</strong> — учётная запись Клиента на Сайте, создаваемая в момент регистрации Клиента и содержащая данные Клиента, указанные при регистрации или последующем изменении сведений, и сведения о Заказах Клиента.</li>
                        <li><strong>Получатель</strong> — физическое лицо, указанное Клиентом при оформлении Заказа в качестве лица, которому Доставщик передает заказанные Товары, либо сам Клиент.</li>
                        <li><strong>Промокод</strong> — уникальная комбинация букв и/или цифр, при условии активации которой (в случае соблюдения Клиентом иных условий использования, указанных в информационном материале к Промокоду и в Правилах), Клиенту предоставляется скидка на стоимость Заказа в размере и на условиях, указанных в правилах соответствующей акции.</li>
                        <li><strong>Самовывоз</strong> — действие Клиента, выражающееся в самостоятельном получении Товара непосредственно в выбранной Клиентом Торговой точке.</li>
                        <li><strong>Сборщик</strong> — ИП, или физическое, или юридическое лицо, оказывающее услуги по Сборке Товара, с которым Клиент при оформлении Заказа заключает договор на Сборку; либо Партнёр e-Feed, осуществляющий Сборку Товара своими силами или с привлечением третьих лиц; либо e-Feed, осуществляющий Сборку Товаров своими силами или с привлечением третьих лиц.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>Какие автоматические решения принимаются на основе данных пользователей</h2>
                    <p>
                        Предприняты необходимые и достаточные технические меры для обеспечения безопасности персональных данных
                        от случайного или несанкционированного доступа, уничтожения, изменения, блокирования доступа и других
                        несанкционированных действий:
                    </p>
                    <ul>
                        <li>Введена система разграничения доступа.</li>
                        <li>Установлена защита от несанкционированного доступа к автоматизированным рабочим местам, информационным сетям и базам персональных данных.</li>
                        <li>Установлена защита от вредоносного программно-математического воздействия.</li>
                        <li>Осуществляется регулярное резервное копированием информации и баз данных.</li>
                        <li>Передача информации по сетям общего пользования осуществляется с использованием средств криптографической защиты информации.</li>
                        <li>Организована система контроля за порядком обработки персональных данных и обеспечения их безопасности. Спланированы проверки соответствия системы защиты персональных данных, аудит уровня защищенности персональных данных в информационных системах персональных данных, функционирования средств защиты информации, выявления изменений в режиме обработки и защиты персональных данных.</li>
                    </ul>
                </section>

                <section className="privacy-section privacy-footer-info">
                    <p>
                        Действующая Политика конфиденциальности размещена на странице по адресу:{' '}
                        <a href="https://e-feed.ru/privacy-policy/" target="_blank" rel="noopener noreferrer">
                            https://e-feed.ru/privacy-policy/
                        </a>
                    </p>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
